import { Comparison } from "@siteimprove/alfa-comparable";
/**
 * {@link https://html.spec.whatwg.org/#concept-slots}
 *
 * @public
 */
export class Slot {
    static of(x, y) {
        return new Slot(x, y);
    }
    _x;
    _y;
    constructor(x, y) {
        this._x = x;
        this._y = y;
    }
    get x() {
        return this._x;
    }
    get y() {
        return this._y;
    }
    compare(slot) {
        // Slots are compared first by y-coordinate, then by x-coordinate. This way,
        // cells will be ordered as they appear in tree-order.
        if (this._y > slot._y) {
            return Comparison.Greater;
        }
        if (this._y < slot._y) {
            return Comparison.Less;
        }
        if (this._x > slot._x) {
            return Comparison.Greater;
        }
        if (this._x < slot._x) {
            return Comparison.Less;
        }
        return Comparison.Equal;
    }
    equals(value) {
        return (value instanceof Slot && value._x === this._x && value._y === this._y);
    }
    toJSON() {
        return {
            x: this._x,
            y: this._y,
        };
    }
}
/**
 * @public
 */
(function (Slot) {
    function isSlot(value) {
        return value instanceof Slot;
    }
    Slot.isSlot = isSlot;
})(Slot || (Slot = {}));
//# sourceMappingURL=slot.js.map